import RefreshInterval from './RefreshInterval';

export default RefreshInterval;
